import Vue from 'vue';
import Vuex from 'vuex';

import idleMonitorPlugin from './plugins/idleMonitor';
import savanna from './modules/savanna';
import localstorage from './modules/localstorage.module';
import broker from './modules/broker.module';
// import { stat } from 'fs';

Vue.use(Vuex);

const debug = false; // process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  state: {
    asideComponent: {},
    userIdle: false
  },
  mutations: {
    setAsideComponent(state, component){
      state.asideComponent = component;
    },
    setUserIdle(state, userIdle) {
      state.userIdle = userIdle;
    }
  },
  modules: {
    savanna,
    localstorage,
    broker
  },
  strict: debug,
  plugins: [idleMonitorPlugin]
});
